/* eslint-disable react/display-name */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2021-10-09 14:50:56
 * Copyright © Leedarson. All rights reserved.
 */
import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';

const Content = memo(({ children, visible, align, origin, maxWidth }) => {
  const el = useRef(null);

  return (
    <div
      ref={el}
      // maxWidth={maxWidth}
      className={`dropdown-content lds-dropdown-content ${align} ${
        visible ? 'visible' : ''
      }`}
      // visible={visible}
      // align={align}
      // origin={origin}
    >
      {children}
    </div>
  );
});

Content.defaultProps = {
  children: null,
  align: 'left',
  origin: 0,
  visible: false,
  maxWidth: 380,
};

Content.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
  maxWidth: PropTypes.number,
  origin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  align: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Content;
